export default __webpack_public_path__ + "static/media/Brew of Vigorous Foresight.130c8eda.jpg";